
import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'

import useBuy from '../../../hooks/nft/useBuy'
import useModal from '../../../hooks/bakery/useModal'
import { useActiveWeb3React } from '../../../hooks'
import { stopPropagation } from '../../../utils/func'
import { useAddPopup } from '../../../state/application/hooks'
import { userTokenDecimals } from '../../../userType/userTokenDecimals'

import { ButtonConfirmed } from '../../Button'
import { AutoRow } from '../../Row'
import Loader from '../../Loader'
import InsufficientModal from '../modal/InsufficientModal'

const Button = styled(ButtonConfirmed)<{bg?: string, color?: string}>`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
  background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
  color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  &:hover{
    background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
    color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  }
`

export default function BuyBtn({artwork, marketType,isMyArtwork, ids, tokenBalance,symbol}: {artwork: any, marketType: string, isMyArtwork?:boolean, ids?: any, tokenBalance: number, symbol?: string}) {
  const { library } = useActiveWeb3React()
  const [requestedBuy, setRequestedBuy] = useState(false)
  const { onBuy } = useBuy(artwork.tokenId, marketType,symbol)
  const addPopup = useAddPopup()

  const [openInsufficientModal] = useModal(
    <InsufficientModal />
  )

  const buyArtwork = useCallback(async (event) => {
    stopPropagation(event)
    if(artwork.level === 'v3'){
      try {
        if (artwork.price !== undefined && new BigNumber(tokenBalance).lt(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice)) {
          openInsufficientModal()
          return
        }
        setRequestedBuy(true)
        let decimals = userTokenDecimals(symbol)
        const price = new BigNumber(+artwork.price).times(new BigNumber(10).pow(decimals)).toString()
        const txHash = await onBuy(price)
  
        if (!txHash) {
          setRequestedBuy(false)
        } else {
          // Seccussful
          if (!library) return
          library
            .getTransactionReceipt(txHash.transactionHash)
            .then(receipt => {
              if (receipt) {
                addPopup(
                  {
                    txn: {
                      hash: txHash.transactionHash,
                      success: receipt.status === 1,
                      summary: 'Buy Digital Artwork NFT'
                    }
                  },
                  txHash.transactionHash
                )
              }
            })
            .catch(error => {
              console.error(`failed to check transaction hash: ${txHash.transactionHash}`, error)
            })
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [onBuy, library, addPopup, artwork, tokenBalance, openInsufficientModal,symbol])

  return (
    <Button
      style={{
        width: artwork.level === 'v1' ? '100%' : ''
      }}
      onClick={buyArtwork}
      disabled={requestedBuy || ids.includes(artwork.tokenId)}
      altDisabledStyle={requestedBuy || ids.includes(artwork.tokenId)}
      bg={artwork.level ==='v3' ||  isMyArtwork ? '' : '#C4C4C4'}
      color={artwork.level ==='v3' ||  isMyArtwork ? '' : '#DEDEDE'}
    >{
      requestedBuy ? (
        <AutoRow gap="6px" justify="center">
          Pending <Loader stroke="white" />
        </AutoRow>
      ) : 'Buy'
    }</Button>
  )
}